// Where does the backend live? (cms, user management, etc)
// export const SPEEDBAG_API = `http://localhost:3000/api/`
export const SPEEDBAG_API = `https://speedbag-react-backend.herokuapp.com/api/`
// export const SPEEDBAG_API = `https://admin.speedbagmlg.com/api/`

// Where does our data api layer live? (crimson hexagon, etc)
export const SPEEDBAG_DATA = `https://speedbag-netbase.herokuapp.com/`
